import { doc, getDoc, getDocs, limit, orderBy, query, serverTimestamp, setDoc, startAfter, updateDoc, where } from "firebase/firestore";
import { meetingRequestDoc, meetingRequestsCollection } from "../models/meetingRequestModel";
import { contactPersonCollection, userDoc } from "../models/userModel";
import { db } from "../../firebase/firebase";
import moment from "moment";

const newId = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charLen = chars.length;
  const maxMultiple = Math.floor(256 / charLen) * charLen;

  const getRandomBytes = (size) => {
    const array = new Uint8Array(size);
    crypto.getRandomValues(array);
    return array;
  };

  let autoId = "";
  const targetLength = 20;

  while (autoId.length < targetLength) {
    const bytes = getRandomBytes(40); // generates 40 random bytes
    for (let i = 0; i < bytes.length; ++i) {
      if (autoId.length < targetLength && bytes[i] < maxMultiple) {
        autoId += chars.charAt(bytes[i] % charLen);
      }
    }
  }

  return autoId;
};

export const getAllMeetingRequests = async ({
    limitCount = 10,
    sortBy = "createdTimestamp",
    searchKey = "",
    startDate = "",
    endDate = "",
    startAfterDoc = null,
    status = "PENDING"
})=>{
let queryConstraints = [];
if(searchKey){
    queryConstraints.push(where("searchKey", "==", searchKey.toLowerCase()));
}
function parseDDMMYYYY(dateStr) {
  const [day, month, year] = dateStr.split("-");
  return new Date(`${year}-${month}-${day}`);
}

 if (startDate && endDate) {
  const start = parseDDMMYYYY(startDate);
  const end = parseDDMMYYYY(endDate);

  queryConstraints.push(
    where("createdTimestamp", ">", start),
    where("createdTimestamp", "<=", end)
  );
}

if(status){
    queryConstraints.push(where("status", "==", status));
}
queryConstraints.push(orderBy(sortBy, "desc"));
  queryConstraints.push(limit(limitCount));
console.log("start", startAfterDoc)
  if (startAfterDoc) {
    const startRef = doc(db, "meetingRequests", startAfterDoc);
    const startSnap = await getDoc(startRef);
    queryConstraints.push(startAfter(startSnap));
  }
  const baseQuery = query(meetingRequestsCollection, ...queryConstraints);
    const snapshot = await getDocs(baseQuery);


     const meetingRequests = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
const response = await Promise.all(
  meetingRequests.map(async (doc) => {
    if (!doc) return null; // null check for doc
// use moment for date formatting
  const createdDate = doc.createdTimestamp ? moment(doc.createdTimestamp.toDate()).format("DD-MM-YYYY") : null;

    return {
      id: doc.id,
      name:doc.name,
      countryCode: doc.countryCode ?? null,
      phoneNumber:doc.phoneNumber ?? null,
      emailId:doc.email ?? null,
      createdDate: createdDate,
      meetingReason:doc.meetingReason ?? null,
    };
  })
);

  return {
    response,
    firstVisible: snapshot.docs[0],
    lastVisible: snapshot.docs[snapshot.docs.length - 1] || null,
  };

  
};

export const rejectMeetingRequest = async (meetingRequestId, approvedById)=>{
    const meetingRequestRef = meetingRequestDoc(meetingRequestId);
    await updateDoc(meetingRequestRef,{
        status: "REJECTED",
        lastModifiedTimestamp: serverTimestamp(),
        approvedBy: userDoc(approvedById)
    })
};

// export const approvedMeetingRequest = async (meetingRequestId, approvedById, assigneeId)=>{

//     // first get meeting person name and phone number and then add it in to the contactPerson collection doc
//     const meetingRequestRef = meetingRequestDoc(meetingRequestId);
//     const meetingRequestSnap = await getDoc(meetingRequestRef);
//     const {firstName, lastName, email, phoneNumber, countryCode}= meetingRequestSnap.data();
//     const generateId = newId();
//     // check if the contact person already exists

//     let duplicateContact = false;
//      const duplicatequery = query(
//         contactPersonCollection,
//         where("phoneNumber", "==", phoneNumber)
//      );
     
// const duplicateContactSnap = await getDocs(duplicatequery);
// if(duplicateContactSnap.docs.length > 0){
//     duplicateContact = true;
// }
// if(!duplicateContact){
//     const contactPersonRef = doc(contactPersonCollection, generateId);
//     await setDoc(contactPersonRef,{
//         name: `${firstName} ${lastName}`,
//         phoneNumber: phoneNumber,
//         countryCode: countryCode,
//         email: email,
//         createdTimestamp: serverTimestamp(),
//         lastModifiedTimestamp: serverTimestamp(),
//         createdBy: userDoc(approvedById),
//         modifiedBy: userDoc(approvedById),
//         searchKey: `${firstName} ${lastName}`.toLowerCase()
//     })
// }

// await updateDoc(meetingRequestRef,{
//     status: "APPROVED",
//     lastModifiedTimestamp: serverTimestamp(),
//     apprrovedBy: userDoc(approvedById),

// })

// // Next create a doc in alertMeetingRequests collection
// const alertMeetingRequestsRef = doc(db, "alertMeetingRequests", generateId);
// await setDoc(alertMeetingRequestsRef, {
//     createdTimestamp: serverTimestamp(),
//     lastModifiedTimestamp: serverTimestamp(),
//     contactPerson: !duplicateContact ? doc(contactPersonCollection, generateId) : duplicateContactSnap.docs[0].ref,
//     approvedBy: userDoc(approvedById),
//     assignedTo: userDoc(assigneeId)
// })

// }


export const approvedMeetingRequest = async (meetingRequestId, approvedById, assigneeId) => {
    const meetingRequestRef = meetingRequestDoc(meetingRequestId);
    const meetingRequestSnap = await getDoc(meetingRequestRef);
    const { name, email, phoneNumber, countryCode } = meetingRequestSnap.data();

    const contactPersonId = newId();
    const alertMeetingRequestId = newId();

    // Check if the contact person already exists
    const duplicateQuery = query(
        contactPersonCollection,
        where("phoneNumber", "==", phoneNumber)
    );
    const duplicateContactSnap = await getDocs(duplicateQuery);
    const duplicateContact = duplicateContactSnap.docs.length > 0;

    let contactPersonRef;
    const contactPersonData = {
        name: name,
        phoneNumber,
        countryCode,
        email,
        createdTimestamp: serverTimestamp(),
        lastModifiedTimestamp: serverTimestamp(),
        createdBy: userDoc(approvedById),
        modifiedBy: userDoc(approvedById),
        searchKey: name.toLowerCase()
    };

    if (!duplicateContact) {
        contactPersonRef = doc(contactPersonCollection, contactPersonId);
    } else {
        contactPersonRef = duplicateContactSnap.docs[0].ref;
    }

    const promises = [];

    // Create contact person if not duplicate
    if (!duplicateContact) {
        promises.push(setDoc(contactPersonRef, contactPersonData));
    }

    // Update meeting request
    promises.push(updateDoc(meetingRequestRef, {
        status: "APPROVED",
        lastModifiedTimestamp: serverTimestamp(),
        apprrovedBy: userDoc(approvedById)
    }));

const messageBody= `You’ve been assigned a new meeting request with ${name}. Please review the details and schedule the meeting 📈.
`
    // Create alertMeetingRequest
    const alertMeetingRequestRef = doc(db, "alertMeetingRequests", alertMeetingRequestId);
    promises.push(setDoc(alertMeetingRequestRef, {
        createdTimestamp: serverTimestamp(),
        lastModifiedTimestamp: serverTimestamp(),
        contactPerson: contactPersonRef,
        approvedBy: userDoc(approvedById),
        assignedTo: userDoc(assigneeId),
        action:messageBody,
        active: true,
        read:false,
        isMeetCreated:false

    }));

    // Run all in parallel
    await Promise.all(promises);
};